<template>
	<div>
		<v-img height="300"
			dark
			:src="require('@/assets/home-hero.jpg')"
			class="white--text"
			gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
		>
			<v-btn color="white"  text rounded to="/productosweb"> <v-icon  >mdi-alarm-light</v-icon> Activos</v-btn>
			<v-btn color="white"  text rounded  to="/clientes"> <v-icon >mdi-account-circle</v-icon> Personal</v-btn>
			
			<v-row align="center" justify="center">
				<v-col class="d-flex justify-center" cols="12">
					<div class="text-center">
						<h1 class="Titulo text-uppercase">Comprobación de Activos </h1>
						<h4 class="subheading"> "Digita o escanea el carnet"</h4>
						<v-tabs color="info" center-active>
							<v-tab @click="Retornar()">Retorno Activos</v-tab>
							<v-tab @click="Asignar()">Asignación Activos</v-tab>
						</v-tabs>
						<v-text-field onfocus="this.select();" ref="cedulaCampo"  @keyup.enter="obtenerCliente()" label="Carnet" type="number" v-model="cedula" />
						
					</div>
				</v-col>
			</v-row>
			
		</v-img>
		<v-row>
			<v-col cols="12" sm="8">
				<v-card
				v-if="cedula != ''"
					:loading="loading"
					max-width="100%"
				>
					<template v-slot:loader="{ isActive }">
					<v-progress-linear
						:active="isActive"
						color="deep-purple"
						height="4"
						indeterminate
					></v-progress-linear>
					</template>
					<v-list-item class="px-2" two-line>
						<v-list-item-avatar>
							<img src="https://www.noah.cr/ImagenesGenerales/usuario.png">
						</v-list-item-avatar>

						<v-list-item-content >
							<v-list-item-title>{{clienteNombre}}</v-list-item-title>
							<v-list-item-subtitle style="font-weight:bold;">Activos asignados</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-simple-table>
						<template v-slot:default>
						<thead>
							<tr>
							<th class="text-left">
								Imagen
							</th>
							<th class="text-left">
								Name
							</th>
							<th class="text-left">
								Fecha
							</th>
							<th class="text-left">
								Acciones
							</th>
							</tr>
						</thead>
						<tbody>
							<tr
							v-for="item in detalles"
							:key="item.name"
							>
							<td><v-img max-height="100" max-width="100" :src="item.localizacion" /> </td>
							<td>{{ item.descripcion }}</td>
							<td>{{ item.origen }}</td>
							<td> <v-btn :loading="loading" @click="RetornoItem(item)" outlined color="success"> Retornar </v-btn> </td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
					<v-divider class="mx-4 mb-1"></v-divider>
					<div v-if="tab == 'Asignacion'"> 
						<v-card-title>Asignar Herramienta</v-card-title>

						<div class="px-4">
							<v-text-field 
							ref="campoAsignacion" 
							id="Asignacion" 
							@keyup.enter="AsignarActivo()" 
							label="Escanear Código Activo" 
							type="number" 
							v-model="codigo" />

						</div>
					</div>
					<div v-else>
						<v-card-title>Retornar Herramienta</v-card-title>

						<div class="px-4">
							<v-text-field ref="campoRetorno"  id="Retorno" @keyup.enter="RetornoItem2()" label="Escanear Código Activo" type="number" v-model="codigo" />
						</div>
					</div>
				</v-card>
			</v-col>
			<v-col cols="12" sm="4" style="border-left: 1px solid #E0E0E0;">
				<v-simple-table dense>
						<template v-slot:default>
						<thead>
							<tr>
							<th class="text-left">
								Ubicación de Activos
							</th>
							<th class="text-left">
								Cantidad
							</th>
							</tr>
						</thead>
						<tbody>
							<tr
							v-for="item in resumen"
							:key="item.name"
							>
							<td>{{ item.actividad }}</td>
							<td>{{ item.cantidad }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
			</v-col>
		</v-row>
	</div>
	
</template>


<script>
  import axios from 'axios';
  export default {
    name: 'InventarioAsignado',
    data () {
      return {
        TipoCedula : '',
        detalles:[],
        cedula: '',
		loading: false,
		tab:null,
		clienteNombre: '',
		codigo:'',
		resumen:[],
      }
    },
	created () {
		this.BuscarProductosPorEmpleado();
    },
    methods: {
		AsignarActivo(){ 
			this.loading = true;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				//Código para editar
				let me=this;
				axios.put('api/Productos/AsignarActivo',{
					'Barcode':this.codigo,
					'Localidad' : 'Construcciones Quepos',
					'Actividad': this.clienteNombre,
				},configuracion).then(function(response){
					me.BuscarActivos();  
					me.codigo = '';           
				}).catch(function(error){
					alert("Problema activo a este operador, envie una foto de este problema a su equipo de soporte"+error);
					alert(error);
				});
		},
		RetornoItem(item){ 
			this.loading = true;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				//Código para editar
				let me=this;
				axios.put('api/Productos/ActualizarActivo',{
					'CodigoProducto':item.codigoProducto,
					'Localidad' : 'Construcciones Quepos',
					'Actividad': 'Bodega',
				},configuracion).then(function(response){
					me.detalles = [];
					me.BuscarActivos();           
				}).catch(function(error){
					alert("Problema agregando el CABYS a al base de datos, envie una foto de este problema a su equipo de soporte"+error);
					alert(error);
				});
		},
		RetornoItem2(){ 
			let Localidad = this.$store.state.usuario.localidad
			this.loading = true;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				//Código para editar
				let me=this;
				axios.put('api/Productos/ActualizarActivo',{
					'CodigoProducto':this.codigo,
					'Localidad' : Localidad,
					'Actividad': 'Bodega',
				},configuracion).then(function(response){
					me.detalles = [];
					me.codigo = '';
					me.BuscarActivos();           
				}).catch(function(error){
					alert("Problema agregando el CABYS a al base de datos, envie una foto de este problema a su equipo de soporte"+error);
					alert(error);
				});
		},
		BuscarProductosPorEmpleado(){
			this.loading = true;
			let header = {"Authorization" : "Bearer "}; // Nota: aquí parece que falta el token de autenticación.
			let configuracion = {headers : header};
			let me = this;

			axios.get('api/Productos/CantidadPorEmpleado', {
				params: {
					localidad: this.$store.state.usuario.localidad
				},
				headers: configuracion.headers
			})
			.then(function(response){
				me.resumen = response.data;
			})
			.catch(function(error){
				alert("Problema obteniendo los productos por empleado, envie una foto de este problema a su equipo de soporte. Error: " + error);
			})
			.finally(() => {
				this.loading = false;
			});
		},
		Retornar(){
			this.tab = 'Retorno'
			this.$refs.cedulaCampo.focus();
		},
		Asignar(){
			this.tab = 'Asignacion'
			this.$refs.cedulaCampo.focus();
		},

		obtenerCliente(){
			var self = this;
			var clientesArray=[];
			this.loading = true;
			var clientePrevio="";
			if (this.cedula.text2 === undefined)
			{
				clientePrevio = this.cedula;
			}
			else
			{
				clientePrevio = this.cedula.text2;
			}
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Empleados/ObtenerClienteCedula', { params: {'clienteFactura': clientePrevio}},configuracion)
				.then(function(response){
				clientesArray=response.data;
				self.clienteNombre = clientesArray[0].nombre;
				self.BuscarActivos();
			})
		},
		BuscarActivos(){
			var self = this;
			self.detalles=[];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Productos/ListarActivos', { params: {'palabra': this.clienteNombre,'Localidad': this.$store.state.usuario.localidad}},configuracion)
				.then(function(response){
				
				self.detalles=response.data;
				self.loading = false;
				if(self.tab == 'Asignacion'){
					self.$refs.campoAsignacion.focus();
				} else
				{
					self.$refs.campoRetorno.focus();
				}
				self.BuscarProductosPorEmpleado();
				
			})
		},
    },
  }
</script>
